<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in" [innerHTML]="actionLabel"></h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12" *ngIf="actionType === 'reviewJobPull'">
            <app-review-candidate-pull-from-job-boards [jobId]="jobId"
               [jbiTransactionId]="jbiTransactionId" [reviewHtmlText]="processedHTMLText"
               [candidateDtoMap]="candidateDtoMap" [notificationId]="notificationId"
               (closeCallback)="closeCallbackModal()">
            </app-review-candidate-pull-from-job-boards>
        </div>
        <div class="col-xs-12" *ngIf="actionType === 'viewAllNotifications'">
            <app-user-notifications [searchObject]="searchObject" [fullView]="true"
                height="300px" pageSize="6" [showFilters]="true" [context]="context"
                [(numberOfNewNotifications)]="numberOfNewNotifications" [(userNotificationControls)]="userNotificationControls"
                [showShortNotification]="false" [jobTypeList]="jobTypeList" [salaryDurationOptions]="salaryDurationOptions">
            </app-user-notifications>
        </div>
        <div class="col-xs-12" *ngIf="actionType === 'candidateBooklet'">
            <app-candidate-job-match-profile
                [jobMatchId]="documentDtoMap?.jobMatchId"
                [jobId]="documentDtoMap?.jobMatchJobId"
                [candidateId]="documentDtoMap?.candidateId"
                [candidateType]="documentDtoMap?.candidateType"
                context="candidateJobMatchCard"
                [documentDtoMap]="documentDtoMap">
            </app-candidate-job-match-profile>
        </div>
        <div class="col-xs-12 px-4" *ngIf="actionType === 'emailNotification'">
            <div class="col-xs-12 px-0">
                <h5 class="mt-0 mb-4 font-bold">Documents Sent</h5>
                <div *ngIf="documentDtoMap?.listOfDocumentsSent && documentDtoMap.listOfDocumentsSent.length > 0">
                    <table class="table table-bordered table-responsive user-configuration-table">
                        <tr>
                            <th class="text-center" style="width: 30px;">No.</th>
                            <th>Document Name</th>
                        </tr>
                        <tr *ngFor="let document of documentDtoMap.listOfDocumentsSent; let i = index">
                            <td class="text-center">{{i + 1}}</td>
                            <td>{{document.documentName ? document.documentName : '-'}}</td>
                        </tr>
                    </table>
                </div>
                <div *ngIf="!documentDtoMap?.listOfDocumentsSent || documentDtoMap.listOfDocumentsSent.length == 0">
                    No Sent Documents.
                </div>
            </div>

            <div class="col-xs-12 px-0">
                <h5 class="my-4 font-bold">Sent to Users</h5>
                <div *ngIf="documentDtoMap?.listOfUsersDocumentsSent && documentDtoMap.listOfUsersDocumentsSent.length > 0">
                    <table class="table table-bordered table-responsive user-configuration-table">
                        <tr>
                            <th class="text-center" style="width: 30px;">No.</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>Company Name</th>
                        </tr>
                        <tr *ngFor="let user of documentDtoMap.listOfUsersDocumentsSent; let i = index">
                            <td class="text-center">{{i + 1}}</td>
                            <td>{{user.firstName ? user.firstName : '-'}}</td>
                            <td>{{user.lastName ? user.lastName : '-'}}</td>
                            <td>{{user.email ? user.email : '-'}}</td>
                            <td>{{user.companyName ? user.companyName : '-'}}</td>
                        </tr>
                    </table>
                </div>
                <div *ngIf="!documentDtoMap?.listOfUsersDocumentsSent || documentDtoMap.listOfUsersDocumentsSent.length == 0">
                    No Sent Users.
                </div>
            </div>
        </div>
        <div class="col-xs-12 px-4" *ngIf="actionType === 'candidateNoLongerMatch'">
            <div class="">
                <div class="clearfix">
                    <div style="max-height: 350px; overflow: auto;">
                        <div *ngIf="notification.reasons.length > 0">
                            <table class="table table-bordered table-responsive">
                                <thead>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let reason of notification.reasons; let i = index">
                                        <td [innerHTML]="reason" class="font-bold" style="line-height: 2; font-size: 13px;">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div *ngIf="!notification.reasons.length">
                            No reasons available.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="px-5 pt-3" *ngIf="actionType === 'outreachNoResponse'">
            <div class="row main-box">
                <div class="col-xs-12 clearfix px-0">
                    <div>
                        <div class="col-xs-12 px-0 outreach-job-match-table">
                            <div class="col-xs-12 mt-4 mb-3"
                                [ngClass]="{'disablescreen': allJobMatchesDisabled || !isSendOutreachAgainEnabled,
                                    'outreach-again-input-padding': sendOutreachAgain, 'pl-3': !sendOutreachAgain}">
                                <input class="outreach-again-checkbox" name="sendOutreachAgain" type="checkbox"
                                    [(ngModel)]="sendOutreachAgain" [disabled]="allJobMatchesDisabled">
                                <label for="sendOutreachAgain" class="outreach-again-label">
                                    Send Candidate Outreach Again
                                </label>
                            </div>
                            <p *ngIf="sendOutreachAgain" class="outreach-again-input-padding">Select the <b>Job Matches</b> you want to include in the <b>Outreach Email</b>:</p>
                            <table width="100%" class="table-bordered feedback-requisitions-table">
                                <thead>
                                    <tr style="line-height: 1.5; background-color: #03a9f426;">
                                        <th class="text-center" style="width: 50px;" *ngIf="sendOutreachAgain">
                                            <input class="cursor-pointer" type="checkbox" [(ngModel)]="selectAllJobMatches"
                                                (change)="toggleSelectAllJobMatches(notification.candidateOutreachJobMatchesInfo.jobMatches)"
                                                tooltip="Select All">
                                        </th>
                                        <th>Req#</th>
                                        <th>Title</th>
                                        <th>{{isStaffingCompany ? 'Client @ Location' : 'Corporate/BU @ Location'}}</th>
                                        <th>Match</th>
                                        <th>Missing/Non matched information</th>
                                        <th>Outreach Status</th>
                                        <th *ngIf="isOutreachExpiryDataExists">Expiry Date</th>
                                        <th>Days since Outreach</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="notification.candidateOutreachJobMatchesInfo.jobMatches && notification.candidateOutreachJobMatchesInfo.jobMatches.length > 0">
                                    <tr *ngFor="let jobMatch of notification.candidateOutreachJobMatchesInfo.jobMatches; let i = index"
                                        [ngClass]="{ 'disablescreen row-disabled': !jobMatch.jobMatchActive || jobMatch.outreachDisabled}">
                                        <td class="text-center position-relative" *ngIf="sendOutreachAgain">
                                            <input class="cursor-pointer" type="checkbox" [(ngModel)]="jobMatch.jobMatchSelected"
                                                (change)="onJobMatchSelectionChange(notification.candidateOutreachJobMatchesInfo.jobMatches)"
                                                [disabled]="jobMatch.outreachDisabled">
                                        </td>
                                        <td><span>{{ jobMatch.requisitionNumber }}</span></td>
                                        <td>
                                            <a class="cursor-pointer" (click)="openModalCallback(jobMatch)">
                                                {{ jobMatch.title }}
                                            </a>
                                            <div class="mt-3 pl-3">
                                                <app-candidate-card-icons context="outreachNoResponse" [candidate]="jobMatch"
                                                    [requisitionSponsorships]="jobMatch.missingOrNonMatchedInfo.requisitionSponsorships"
                                                    [candidateAdditionalDetails]="jobMatch.missingOrNonMatchedInfo"
                                                    [candidateSalaryDurationOptions]="salaryDurationOptions"
                                                    [jobTypeList]="jobTypeList">
                                                </app-candidate-card-icons>
                                            </div>
                                            <div class="outreach-job-match-detail-container">
                                                <div class="outreach-job-match-detail-row">
                                                    <span class="outreach-job-match-detail-heading">Preferred Job Type:</span>
                                                    <span class="outreach-job-match-detail-value">{{jobMatch.jobDetails.preferredJobType}}</span>
                                                </div>
                                                <div class="outreach-job-match-detail-row">
                                                    <span class="outreach-job-match-detail-heading">Salary/Rate:</span>
                                                    <span class="outreach-job-match-detail-value">{{jobMatch.jobDetails.salary}}</span>
                                                </div>
                                                <div class="outreach-job-match-detail-row">
                                                    <span class="outreach-job-match-detail-heading">Sponsorship:</span>
                                                    <span class="outreach-job-match-detail-value">{{jobMatch.jobDetails.sponsorships}}</span>
                                                </div>
                                                <div class="outreach-job-match-detail-row">
                                                    <span class="outreach-job-match-detail-heading">Work Location:</span>
                                                    <span class="outreach-job-match-detail-value">{{jobMatch.jobDetails.workLocations}}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>{{jobMatch.companyLocationLabel}}</td>
                                        <td>
                                            <div class="mb-2">
                                                {{jobMatch.candidateMatch}}
                                            </div>
                                            <div class="cursor-pointer" [ngClass]="{'user-notification-outreach-matched-score': jobMatch.isScoreMatched, 'user-notification-outreach-failure-score': !jobMatch.isScoreMatched}"
                                                tooltip="Threshold Score is {{jobMatch.thresholdScore}}" (click)="openJobCompareModalCallback(jobMatch)">
                                                {{jobMatch.score}}
                                            </div>
                                        </td>
                                        <td class="px-2">
                                            <ul *ngIf="jobMatch.missingOrNonMatched.length > 0" class="list-unstyled">
                                                <li *ngFor="let missingInfo of jobMatch.missingOrNonMatched; let mi = index">
                                                    <span>{{mi + 1}}. {{ missingInfo }}</span>
                                                    <span class="fa fa-exclamation-circle red ml-2" tooltip="Missing Information"
                                                     style="font-size: 12px;"></span>
                                                </li>
                                            </ul>
                                            <p *ngIf="!jobMatch.missingOrNonMatched || jobMatch.missingOrNonMatched.length == 0"
                                                class="d-flex justify-content-center">-</p>
                                        </td>
                                        <td>
                                            {{ jobMatch.formattedOutreachStatus }}
                                        </td>
                                        <td *ngIf="isOutreachExpiryDataExists">
                                            {{ jobMatch.outreachExpiryDate ? jobMatch.outreachExpiryDate : '-' }}
                                        </td>
                                        <td>{{ jobMatch.daysSinceOutreach }}</td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="!notification.candidateOutreachJobMatchesInfo.jobMatches || notification.candidateOutreachJobMatchesInfo.jobMatches.length == 0">
                                    <tr>
                                        <td colspan="8" class="text-center">No Job Matches Found</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row main-box" *ngIf="sendOutreachAgain">
                <div class="d-flex justify-content-between align-items-center py-4">
                    <p class="mb-0 pl-4 font-bold">Do you want us to send the candidate an outreach email again?</p>
                    <div class="mr-4">
                        <button class="btn btn-danger mr-2" (click)="closeModal()">No</button>
                        <button class="btn btn-primary"
                            (click)="sendCandidateOutreachAgain(notification.candidateOutreachJobMatchesInfo.jobMatches)">Yes</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 px-4" *ngIf="actionType === 'bulkUploadDetails'">
            <p class="mb-3" *ngIf="bulkUploadHeading" [innerHTML]="bulkUploadHeading"></p>
            <div class="bulk-upload-summary">
                <div class="clearfix mb-3">
                    <span class="font-bold">Bulk Resume Upload</span>
                    <span class="label ml-2" [ngClass]="candidateDtoMap?.status === 'COMPLETED' ? 'label-success' : 'label-info'">
                        {{candidateDtoMap?.status === 'COMPLETED' ? 'Completed' : 'In Progress'}}
                    </span>
                    <span class="pull-right">
                        {{candidateDtoMap?.processedResumes || 0}} / {{candidateDtoMap?.totalResumes || 0}} resumes processed
                    </span>
                </div>
                <div class="progress progress-4x mb-4">
                    <div class="progress-bar" [class.progress-bar-success]="candidateDtoMap?.status === 'COMPLETED'" role="progressbar"
                        [style.width.%]="candidateDtoMap?.progressPercentage || 0">
                        {{candidateDtoMap?.progressPercentage || 0}}%
                    </div>
                </div>
                <div class="row text-center">
                    <div class="col-xs-4">
                        <div class="bulk-upload-stat-value bulk-upload-stat-total">{{candidateDtoMap?.totalResumes || 0}}</div>
                        <div class="bulk-upload-stat-label">Total</div>
                    </div>
                    <div class="col-xs-4">
                        <div class="bulk-upload-stat-value bulk-upload-stat-success">{{candidateDtoMap?.successResumes || 0}}</div>
                        <div class="bulk-upload-stat-label">Successful</div>
                    </div>
                    <div class="col-xs-4">
                        <div class="bulk-upload-stat-value bulk-upload-stat-failed">{{candidateDtoMap?.failedResumes || 0}}</div>
                        <div class="bulk-upload-stat-label">Failed</div>
                    </div>
                </div>
            </div>
            <div class="mt-4" *ngIf="bulkUploadFailedFiles.length > 0">
                <h5 class="mt-0 mb-3 font-bold">Failed Files</h5>
                <div style="max-height: 300px; overflow: auto;">
                    <table class="table table-bordered table-responsive user-configuration-table bulk-upload-table">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 30px;">No.</th>
                                <th>File Name</th>
                                <th>Folder</th>
                                <th>Reason</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let file of bulkUploadFailedFiles; let i = index">
                                <td class="text-center">{{i + 1}}</td>
                                <td>{{file.fileName || '-'}}</td>
                                <td>{{file.directoryName || '-'}}</td>
                                <td>{{file.reason || file.error || '-'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-xs-12" *ngIf="actionType === 'jobProfile'">
            <app-job-profile [jobId]="notification.jobId" context="outreach" (closeModalCallback)="closeModal()"></app-job-profile>
        </div>
        <div class="col-xs-12" *ngIf="actionType === 'jobCompare'">
            <app-candidate-job-match-profile [jobId]="notification.jobId" [candidateId]="candidateId"
                [jobMatchId]="notification.jobMatchId" context="candidateJobComparison">
            </app-candidate-job-match-profile>
        </div>
        <div class="col-xs-12" *ngIf="actionType === 'resumeProcessedCandidates'">
            <app-upload-resumes-processed-candidates [candidatesCount]="candidatesCount" [jobId]="bulkUploadJobId"
                [candidateId]="candidateId" [notificationId]="notificationId" [headingTitle]="headingTitle"
                [outreachSent]="!!notification?.outreachSent" (outreachSentCallback)="markOutreachSent()" (completeCallback)="closeModal()">
            </app-upload-resumes-processed-candidates>
        </div>
    </div>
</div>
